export const apiUrl =
  process.env.API_URL || "https://foodieuniverse.onrender.com";
//process.env.API_URL || "https://localhost:4000/";
export const DEFAULT_MESSAGE_TIMEOUT = 2000;
